import { render, staticRenderFns } from "./AddEditSubEventSponsorDetails.vue?vue&type=template&id=40955ef2&scoped=true"
import script from "./AddEditSubEventSponsorDetails.vue?vue&type=script&lang=js"
export * from "./AddEditSubEventSponsorDetails.vue?vue&type=script&lang=js"
import style0 from "./AddEditSubEventSponsorDetails.vue?vue&type=style&index=0&id=40955ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40955ef2",
  null
  
)

export default component.exports